module.exports = require("@nestjs/platform-socket.io");